//interface for columns
interface ColumnMeta {
    field: string;
    header: string;
}

//College Management Columns
export const CollegeManagementColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'full_name', header: 'College Name' },
    { field: 'email', header: 'Email' },
    { field: 'mobile', header: 'Mobile' },
    { field: 'pci_college_code', header: 'College Code' },
    { field: 'principal_name', header: 'Principal Name' },
    { field: 'principal_sign', header: 'Signature' },
    { field: 'proof_of_college', header: 'Principal Id' },
    { field: 'is_approved', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// pci aproval list col
export const PciListColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'pci_code', header: 'PCI Code' },
    { field: 'from_year', header: 'From Year' },
    { field: 'to_year', header: 'To Year' },
    { field: 'degree_name', header: 'Degree' },
    { field: 'approval_file', header: 'File' },
    { field: 'status', header: 'Status' }
];

// pending pci approval list
export const PendingPciListColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'college_name', header: 'College Name' },
    { field: 'pci_code', header: 'PCI Code' },
    { field: 'from_year', header: 'From Year' },
    { field: 'to_year', header: 'To Year' },
    { field: 'degree_name', header: 'Degree' },
    { field: 'approval_file', header: 'File' },
    { field: 'status', header: 'Status' }
];

// pending admitted list
export const PendingAdmittedListColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'college_name', header: 'College Name' },
    { field: 'from_year', header: 'From Year' },
    { field: 'to_year', header: 'To Year' },
    { field: 'degree_name', header: 'Degree' },

    { field: 'reason', header: 'Reason' },
    { field: 'status', header: 'Status' },
    { field: 'change_status', header: 'Change Status' },
    { field: 'action', header: 'Action' }
];

// pending admitted list
export const PendingPassoutListColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'college_name', header: 'College Name' },
    { field: 'from_year', header: 'From Year' },
    { field: 'to_year', header: 'To Year' },
    { field: 'degree_name', header: 'Degree' },
    { field: 'passout_status', header: 'Passout Status' },
    { field: 'reason', header: 'Reason' },
    { field: 'status', header: 'Status' },
    { field: 'change_status', header: 'Change Status' },
    { field: 'action', header: 'Action' }
];

// admitted list col
export const AdmittedListColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'from_year', header: 'From Year' },
    { field: 'to_year', header: 'To Year' },
    { field: 'degree_name', header: 'Degree' },
    { field: 'action', header: 'Action' }
];

// passout list col
export const PassoutListColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'from_year', header: 'From Year' },
    { field: 'to_year', header: 'To Year' },
    { field: 'degree_name', header: 'Degree' },
    { field: 'passout_status', header: 'Passout Status' },
    { field: 'action', header: 'Action' }
];

// admit detail col
export const admitColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'first_name', header: 'First Name' },
    { field: 'middle_name', header: 'Middle Name' },
    { field: 'last_name', header: 'Last Name' },
    { field: 'dob', header: 'Date of Birth' },
    { field: 'enrollment_no', header: 'Enrollment No' },
    { field: 'admitted_year', header: 'Admitted Year' }
];

// passout detail col
export const passoutColumns = [
    {
        field: 'sr_no',
        header: 'Sr No.'
    },
    { field: 'first_name', header: 'First Name' },
    { field: 'middle_name', header: 'Middle Name' },
    { field: 'last_name', header: 'Last Name' },
    { field: 'dob', header: 'Date of Birth' },
    { field: 'enrollment_no', header: 'Enrollment No' },
    { field: 'admitted_year', header: 'Admitted Year' }
];

// Fresh Application Columns
export const FreshApplicationColumns: ColumnMeta[] = [
    // { field: 'sr_no', header: 'Sr No.' },
    { field: 'full_name', header: 'Name' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'BillSrNo', header: 'Payment Ref No.' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'slot_data.slot_details.date', header: 'Appointment Date' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'College Name' },
    { field: 'appStatus', header: 'Status' },
    { field: 'comment', header: 'Reason' },
    { field: 'action', header: 'Action' }
];
// view All Book Appointment Columns
export const ViewAllBookAppointmentColumns: ColumnMeta[] = [
    // { field: 'sr_no', header: 'Sr No.' },
    { field: 'name', header: 'Name' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'BillSrNo', header: 'Payment Ref No.' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'appointment_date', header: 'Appointment Date' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'College Name' },
    { field: 'appStatus', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// Fresh Application Other Payment Pending Columns
export const FreshApplicationOtherPaymentPendingColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Name' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'BOD', header: 'DOB' },
    { field: 'PPhone', header: 'Phone' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'College Name' },
    { field: 'JoingYth', header: 'Joining Year' },
    { field: 'Passedyth', header: 'Passing Year' },
    { field: 'appStatus', header: 'Status' },
    { field: 'pendingaction', header: 'Action' }
];

// Fresh Application Other Payment Done Columns
export const FreshApplicationOtherPaymentDoneColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Name' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'BillSrNo', header: 'Payment Ref No.' },
    { field: 'slot_data.slot_details.date', header: 'Appointment Date' },
    { field: 'PayDt', header: 'Date' },
    { field: 'BOD', header: 'DOB' },
    { field: 'PPhone', header: 'Phone' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'College Name' },
    { field: 'JoingYth', header: 'Joining Year' },
    { field: 'Passedyth', header: 'Passing Year' },
    { field: 'appStatus', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// Eligible Application Columns
export const EligibleApplicationColumns: ColumnMeta[] = [
    // { field: 'sr_no', header: 'Sr No.' },
    { field: 'full_name', header: 'Name' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'BillSrNo', header: 'Payment Ref No.' },
    { field: 'PayDt', header: 'Date' },
    { field: 'BOD', header: 'DOB' },
    { field: 'PPhone', header: 'Phone' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'College Name' },
    { field: 'JoingYth', header: 'Joining Year' },
    { field: 'Passedyth', header: 'Passing Year' },
    { field: 'RegApproved', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// Renew Application columns
export const RenewApplicationColumns: ColumnMeta[] = [
    { field: 'StudNm', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'LastVDate', header: 'Validity' },
    { field: 'EntryNo', header: 'File No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'EntDt', header: 'Payment Date' },
    { field: 'applicant_details.user.email', header: 'User Email' },
    { field: 'applicant_details.user.mobile', header: 'User Phone' },
    // { field: 'DegNm', header: 'Qualification' },
    { field: 'verified_by', header: 'Issued by' },
    { field: 'comment', header: 'Reason' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// ReEntry Application columns
export const ReEntryApplicationColumns: ColumnMeta[] = [
    { field: 'StudNm', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'LastVDate', header: 'Validity' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'EntDt', header: 'Payment Date' },
    { field: 'applicant_details.user.email', header: 'User Email' },
    { field: 'applicant_details.user.mobile', header: 'User Phone' },
    // { field: 'DegNm', header: 'Qualification' },
    { field: 'verified_by', header: 'Issued By' },
    { field: 'comment', header: 'Reason' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// View Document Columns
export const ViewDocumentColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'doc_name', header: 'Document Name' },
    { field: 'view', header: 'View' },
    { field: 'upload', header: 'Upload' },
    { field: 'verification', header: 'Verification' },
    { field: 'uploaded_by', header: 'Uploaded By' }
];

// View Other Document Columns
export const ViewOtherDocumentColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'doc_name', header: 'Document Name' },
    { field: 'view', header: 'View' },
    { field: 'upload', header: 'Upload' },
    { field: 'verification', header: 'Verification' },
    { field: 'uploaded_status', header: 'Uploaded By' }
];

// Duplicate Columns
export const DuplicateColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'File No.' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'BOD', header: 'DOB' },
    { field: 'full_name', header: 'Name' }
];

// Verification List Columns
export const VerificationListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'comment', header: 'Verification Note' },
    { field: 'verification_to', header: 'Verification To' },
    { field: 'created_at', header: 'Verification Order Date' },
    { field: 'verification_date', header: 'Verification Send Date' },
    { field: 'file_url', header: 'Verification Files' },
    { field: 'reply', header: 'Reply' },
    { field: 'reply_file', header: 'Reply Files' },
    { field: 'action', header: 'Action' }
];

// Electoral Columns
export const ElectoralColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'StudNm', header: 'Full Name' },
    { field: 'created_at', header: 'Application Date' },
    { field: 'LastVDate', header: 'Validity Date' }
];

// Election Deposit Columns
export const ElectionDepositColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'StudNm', header: 'Full Name' },
    { field: 'created_at', header: 'Application Date' },
    { field: 'LastVDate', header: 'Validity Date' },
    { field: 'AppAccept', header: 'Status' }
];

// Address Change Columns
export const AddressChangeColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Name' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'new_address', header: 'Address' },
    { field: 'new_city', header: 'City' },
    { field: 'new_dist', header: 'District' },
    { field: 'new_taluka', header: 'Taluka' },
    { field: 'ApplicationDate', header: 'Date' },
    { field: 'add_status', header: 'Status' },
    { field: 'comment', header: 'Reason' },
    { field: 'verified_by', header: 'Issued By' },
    { field: 'action', header: 'Action' }
];

// Name Change Columns
export const NameChangeColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'StudNm', header: 'Change Name' },
    { field: 'email', header: 'Email' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'comment', header: 'Reason' },
    { field: 'verified_by', header: 'Issued By' },
    { field: 'action', header: 'Action' }
];

// Good Standing Columns
export const GoodStandingColumns: ColumnMeta[] = [
    { field: 'StudNm', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'EntryNo', header: 'File No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'comment', header: 'Reason' },
    { field: 'verified_by', header: 'Issued By' },
    { field: 'action', header: 'Action' }
];

// Duplicate Certificate Columns
export const DuplicateCertificateColumns: ColumnMeta[] = [
    { field: 'StudNm', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'LastVDate', header: 'Validity ' },
    { field: 'EntryNo', header: 'File No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'comment', header: 'Reason' },
    { field: 'verified_by', header: 'Issued By' },
    { field: 'action', header: 'Action' }
];

// Degree Addition Columns
export const DegreeAdditionColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'StudNm', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColNm', header: 'College Name' },
    { field: 'applicant_details.user.email', header: 'User Email' },
    { field: 'applicant_details.user.mobile', header: 'User Phone' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'comment', header: 'Reason' },
    { field: 'action', header: 'Action' }
];

// Penalty List
export const PenaltyListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'EntryNo', header: 'File No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'StudNm', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'AppAccept', header: 'Status' },
    { field: 'action', header: 'Action' }
];
export const PenaltyJanVishwasListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'EntryNo', header: 'File No.' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'penalty_under_jan_vishwas_amount', header: 'Penalty Amount' },
    { field: 'StudNm', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'AppAccept', header: 'Status' }
];

// Penalty List
export const RegistrationCancellationColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'File No.' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'RegCDate', header: 'Reg Cancel Date' },
    { field: 'RegCBy', header: 'Registration CBY' },
    { field: 'RegCNote', header: 'Reg Note' },
    { field: 'action', header: 'Action' }
];

// Permanent Reg Cancellation List
export const PermanentRegCancellationListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'File No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'RegCDate', header: 'Reg Cancel Date' },
    { field: 'RegCBy', header: 'Registration CBY' },
    { field: 'RegCNote', header: 'Reg Note' }
];

// Pro To Org List
export const ProToOrgListColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Full Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'PAddress', header: 'Address' },
    { field: 'PEmail', header: 'Email' },
    { field: 'PPhone', header: 'Mobile' },
    { field: 'created_at', header: 'Date' },
    { field: 'generate_status', header: 'Status' },
    { field: 'pro_to_original_url', header: 'Provisional' },
    { field: 'degree_certi_url', header: 'Degree Certy' },
    { field: 'action', header: 'Action' }
];

// Search Details Columns
export const SearchDetailsColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'StudF', header: 'First Name' },
    { field: 'StudM', header: 'Middle Name' },
    { field: 'StudL', header: 'Surname' },
    { field: 'BOD', header: 'DOB' },
    { field: 'Gender', header: 'Gender' },
    { field: 'ColName', header: 'College Name' },
    { field: 'JoingYth', header: 'Join Year' },
    { field: 'Passedyth', header: 'Passed Year' },
    { field: 'penalty_status', header: 'Penalty Status' },
    { field: 'penalty_under_jan_vishwas_status', header: 'Penalty under Jan Vishwas' }
];

// Online Refresher Course List Columns
export const OnlineRefresherCourseColumnsList: ColumnMeta[] = [
    { field: 'id', header: 'Code' },
    { field: 'orgnameeng', header: 'College Name' },
    { field: 'start_date', header: 'Start Date' },
    { field: 'end_date', header: 'End Date' },
    { field: 'total_slot', header: 'Total Slots' },
    { field: 'booked_slot', header: 'Booked' },
    { field: 'available_slot', header: 'Available' },
    { field: 'status', header: 'Booking' },
    { field: 'published_status', header: 'Published ' },
    { field: 'quiz_published_status', header: 'Exam' },
    { field: 'action', header: 'Action' }
];

// Refresher Course Booked Slots Columns
export const RefresherCourseBookedColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'File No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'full_name', header: 'Name' },
    // { field: 'BOD', header: "Date Of Birth" },
    { field: 'mobile', header: 'Contact No.' },
    // { field: 'email', header: 'Email' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'present_institute', header: 'Current Org.' },
    { field: 'designation', header: 'Designation' }
];

// Refresher Course Certification Columns
export const RefresherCourseCertificationColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'full_name', header: 'Name' },
    { field: 'lec_1_attended', header: 'Session 1' },
    { field: 'lec_2_attended', header: 'Session 2' },
    { field: 'lec_3_attended', header: 'Session 3' },
    { field: 'lec_4_attended', header: 'Session 4' },
    { field: 'lec_5_attended', header: 'Session 5' },
    { field: 'lec_6_attended', header: 'Session 6' },
    { field: 'lec_7_attended', header: 'Session 7' },
    { field: 'lec_8_attended', header: 'Session 8' },
    { field: 'exam_attended', header: 'Exam Attended' },
    { field: 'total_session_attended', header: 'Total Present' },
    { field: 'result', header: 'Exam Result' },
    { field: 'summary', header: 'Result Summary' },
    // { field: 'refresher_certy_status', header: 'Cert. Status' },
    { field: 'refresher_certy_status', header: 'Certificate' },
    { field: 'feedback', header: 'Feedback' }
    // { field: 'certificate', header: 'Certificate' }
];

// Offline Refresher Course Certification Columns
export const OfflineRefresherCourseCertificationColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'full_name', header: 'Name' },
    { field: 'lec_1_attended', header: 'Session 1' },
    { field: 'lec_2_attended', header: 'Session 2' },
    { field: 'lec_3_attended', header: 'Session 3' },
    { field: 'lec_4_attended', header: 'Session 4' },
    { field: 'lec_5_attended', header: 'Session 5' },
    { field: 'lec_6_attended', header: 'Session 6' },
    { field: 'lec_7_attended', header: 'Session 7' },
    { field: 'lec_8_attended', header: 'Session 8' },
    { field: 'exam_attended', header: 'Exam Attended' },
    { field: 'total_session_attended', header: 'Total Present' },
    { field: 'result', header: 'Exam Result' },
    { field: 'summary', header: 'Result Summary' },
    { field: 'refresher_certy_status', header: 'Certificate' }
];

// Refresher Course Certification List Columns
export const RefresherCourseCertificationListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Sr No' },
    { field: 'name', header: 'Name' },
    { field: 'email', header: 'Email' },
    { field: 'designation', header: 'Designation' },
    { field: 'topic', header: 'Topic Name' },
    { field: 'certificate', header: 'Certificate' }
];

// Offline Refresher Course List Columns
export const OfflineRefresherCourseColumnsList: ColumnMeta[] = [
    { field: 'id', header: 'Code' },
    // { field: 'refresher_course_name', header: 'Course Name' },
    { field: 'orgnameeng', header: 'College Name' },
    { field: 'start_date', header: 'Start Date' },
    { field: 'end_date', header: 'End Date' },
    { field: 'total_slot', header: 'Total Slots' },
    { field: 'booked_slot', header: 'Booked' },
    { field: 'available_slot', header: 'Available' },
    { field: 'booking_status', header: 'Booking' },
    { field: 'published_status', header: 'Published' },
    { field: 'action', header: 'Action' }
];

// User Management List Columns
export const UserManagementListColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Name' },
    { field: 'email', header: 'Email' },
    { field: 'user_type', header: 'Role' },
    { field: 'mobile', header: 'Mobile' },
    { field: 'action', header: 'Action' }
];

// Booked Appointment Columns
export const BookedAppointmentColumns: ColumnMeta[] = [
    { field: 'date', header: 'Date' },
    { field: 'app_id', header: 'Application Type' },
    { field: 'slot_start_time', header: 'Time Start' },
    { field: 'slot_end_time', header: 'Time End' },
    { field: 'slot_total_members', header: 'Total Slot' },
    { field: 'ava_slots', header: 'Available Slot' },
    { field: 'action', header: 'Action' }
];

//AppointmentList columns
export const AppointmentListColumns: ColumnMeta[] = [
    { field: 'date', header: 'Date' },
    { field: 'appointment_time', header: 'Appointment Time' },
    { field: 'slot_total_members', header: 'Total Slots' },
    { field: 'booked_members', header: 'Booked Slots' },
    { field: 'ava_slots', header: 'Available Slots' },
    { field: 'action', header: 'Action' }
];

// User Appointment List Columns
export const UserAppointmentListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'applicant_details.SrNo', header: 'File No.' },
    { field: 'user_details.full_name', header: 'Name' },
    { field: 'user_details.email', header: 'Email' },
    { field: 'user_details.mobile', header: 'Mobile No.' }
];

// Bank Entry List Columns
export const BankEntryListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'CurrDate', header: 'Date' },
    { field: 'RefNo', header: 'Voucher No' },
    { field: 'AccName', header: 'Account Name' },
    { field: 'OthMsg', header: 'D/W' },
    { field: 'Debit', header: 'Debit' },
    { field: 'Credit', header: 'Credit' },
    { field: 'CqNo', header: 'Chq No' },
    { field: 'Message', header: 'Remark' },
    { field: 'action', header: 'Action' }
];

// Cash Entry List Columns
export const CashEntryListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'CurrDate', header: 'Date' },
    { field: 'RefNo', header: 'Voucher No' },
    { field: 'AccName', header: 'Account Name' },
    { field: 'OthMsg', header: 'P/R' },
    { field: 'Debit', header: 'Debit' },
    { field: 'Credit', header: 'Credit' },
    { field: 'Message', header: 'Remark' },
    { field: 'action', header: 'Action' }
];

// JV Entry List Columns
export const JVEntryListColumns: ColumnMeta[] = [
    { field: 'AccName', header: 'Account Name' },
    { field: 'Credit', header: 'Credit' },
    { field: 'Debit', header: 'Debit' },
    { field: 'Message', header: 'Remark' }
];

// JV Entry Add List Columns
export const JVEntryAddListColumns: ColumnMeta[] = [
    { field: 'AccNm', header: 'Account Name' },
    { field: 'Credit', header: 'Credit Amt' },
    { field: 'Debit', header: 'Debit Amt' },
    { field: 'Message', header: 'Remark' },
    { field: 'action', header: 'Action' }
];

// Account Master List Columns
export const AccountMasterListColumns: ColumnMeta[] = [
    { field: 'AccName', header: 'Account Name' },
    { field: 'GroupSrNo', header: 'Account Group' },
    { field: 'OpBalance', header: 'Opening Balance' },
    { field: 'acc', header: 'Type' },
    { field: 'action', header: 'Action' }
];

// Account Group List Columns
export const AccountGroupListColumns: ColumnMeta[] = [
    { field: 'GroupName', header: 'Group Name' },
    { field: 'HeadSrNo', header: 'Group' },
    { field: 'Sequence', header: 'Sequence' },
    { field: 'action', header: 'Action' }
];

// Billing List Columns
export const BillingListColumns: ColumnMeta[] = [
    { field: 'EntryNo', header: 'File No.' },
    { field: 'bRegNo', header: 'Reg No.' },
    { field: 'StudNm', header: 'Name' },
    { field: 'TotalAmt', header: 'Amount' },
    { field: 'BillSrNo', header: 'Bill No' },
    { field: 'PayDt', header: 'Date' },
    { field: 'AppNm', header: 'Application' },
    { field: 'NoOFYrReg', header: 'Year' }
];

// Provisional List Columns
export const ProvisionalListShowColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'RegDt', header: 'Reg Date' },
    { field: 'ProIDate', header: 'Issue Date' },
    { field: 'PAddress', header: 'Address' },
    { field: 'action', header: 'Action' }
];

// Provisional List Columns
export const ProvisionalListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'File No.' },
    { field: 'full_name', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'BOD', header: 'DOB' },
    { field: 'ProIDate', header: 'Issue Date' },
    { field: 'PAddress', header: 'Address' }
];

// Original List Columns
export const OriginalListShowColumns: ColumnMeta[] = [
    { field: 'EntryNo', header: 'File No' },
    { field: 'Name', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'RegDt', header: 'Reg Date' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'OrgIDt', header: 'Issue Date' },
    { field: 'action', header: 'Action' }
];

// Remaining Original List Columns
export const RemainingOriginalListShowColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'File No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'RegDt', header: 'Reg Date' },
    { field: 'full_name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'BOD', header: 'DOB' },
    { field: 'PAddress', header: 'Address' }
];

// Duplicate Cert List Columns
export const DuplicateCertListShowColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'EntryNo', header: 'File No' },
    { field: 'billSrNo', header: 'Payment Ref No.' },
    { field: 'created_at', header: 'Date' },
    { field: 'StudNm', header: 'Full Name' },
    { field: 'file_url', header: 'Certificate' },
    { field: 'duplicate_certificate_status', header: 'Generate Status' },
    { field: 'action', header: 'Action' }
];

// Additional Cert List Columns
export const AdditionalCertListShowColumns: ColumnMeta[] = [
    { field: 'RNo', header: 'File No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'Name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'DCertIDt', header: 'Issue Date' },
    { field: 'action', header: 'Action' }
];

// GoodStanding Cert List Show Columns
export const GoodStandingCertListShowColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'country', header: 'Country' },
    { field: 'CertI', header: 'Cert Issue' },
    { field: 'CertIDt', header: 'Issue Date' },
    { field: 'action', header: 'Action' }
];

// Add Inward Register List Columns
export const AddInwardRegisterListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Inward No.' },
    { field: 'EntDt', header: 'Inward Date' },
    { field: 'FromNm', header: 'From' },
    { field: 'ToNm', header: 'To' },
    { field: 'Sub', header: 'Subject' },
    { field: 'RegNo', header: 'Registration No./ Letter No.' },
    { field: 'main_type', header: 'Main Type' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'Note1', header: 'Note' },
    { field: 'action', header: 'Action' }
];

// Inward Register List Columns
export const InwardRegisterListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Inward No.' },
    { field: 'EntDt', header: 'Inward Date' },
    { field: 'FromNm', header: 'From' },
    { field: 'ToNm', header: 'To' },
    { field: 'Sub', header: 'Subject' },
    { field: 'RegNo', header: 'Registration No./ Letter No.' },
    { field: 'main_type', header: 'Main Type' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'Note1', header: 'Note' }
];

// Add Outward Register List Columns
export const AddOutwardRegisterListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Outward No.' },
    { field: 'EntDt', header: 'Outward Date' },
    { field: 'FromNm', header: 'From' },
    { field: 'ToNm', header: 'To' },
    { field: 'Sub', header: 'Subject' },
    { field: 'RegNo', header: 'Registration No./ Letter No.' },
    { field: 'main_type', header: 'Main Type' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'Note1', header: 'Note' },
    { field: 'action', header: 'Action' }
];

// Outward Register List Columns
export const OutwardRegisterListColumns: ColumnMeta[] = [
    { field: 'SrNo', header: 'Outward No.' },
    { field: 'EntDt', header: 'Outward Date' },
    { field: 'FromNm', header: 'From' },
    { field: 'ToNm', header: 'To' },
    { field: 'Sub', header: 'Subject' },
    { field: 'RegNo', header: 'Registration No./ Letter No.' },
    { field: 'main_type', header: 'Main Type' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'Note1', header: 'Note' }
];

// Department List Columns
export const DepartmentListColumns: ColumnMeta[] = [
    { field: 'dname', header: 'Department Name' },
    { field: 'action', header: 'Action' }
];

// Student List Columns
export const StudentListColumns: ColumnMeta[] = [
    { field: 'name', header: 'Name' },
    { field: 'qualification', header: 'Edu. Qual.' },
    { field: 'expdetails', header: 'Exp. Details' },
    { field: 'yearexp', header: 'Years of Exp.' },
    { field: 'dname', header: 'Department' },
    { field: 'job_name', header: 'Job Type' },
    { field: 'aname', header: 'Location' },
    { field: 'cphone', header: 'Contact' },
    { field: 'created_at', header: 'DOP' },
    { field: 'status', header: 'Status' },
    { field: 'approve', header: 'Approve' },
    { field: 'action', header: 'Action' }
];

// Job List Columns
export const JobListColumns: ColumnMeta[] = [
    { field: 'cname', header: 'Company Name' },
    { field: 'jtitle', header: 'Job Title' },
    { field: 'dname', header: 'Department' },
    { field: 'job_name', header: 'Job Type' },
    { field: 'aname', header: 'Location' },
    { field: 'contactphone', header: 'Contact' },
    { field: 'created_at', header: 'DOP' },
    { field: 'exp_created_at', header: 'Date Of Expiry' },
    { field: 'status', header: 'Status' },
    { field: 'approve', header: 'Approve' },
    { field: 'action', header: 'Action' }
];

// Application Bill Master Columns
export const ApplicationBillMasterColumns: ColumnMeta[] = [
    { field: 'BillItem', header: 'Item Name' },
    { field: 'ItemValue', header: 'Amount' }
];

// Applications List Columns
export const ApplicationsListColumns: ColumnMeta[] = [
    { field: 'AppName', header: 'Application Name' },
    { field: 'action', header: 'Action' }
];

// Document Master List Columns
export const DocumentMasterListColumns: ColumnMeta[] = [
    { field: 'docName', header: 'Document Name' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action' }
];

// AddDocument Master List Columns
export const AddDocumentMasterListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'DocName', header: 'Document Name' },
    { field: 'action', header: 'Action' }
];

// Board Master List Columns
export const BoardMasterListColumns: ColumnMeta[] = [
    { field: 'BoardNm', header: 'Board Name' },
    { field: 'StateNm', header: 'State' },
    { field: 'action', header: 'Action' }
];

// Approval  Master List Columns
export const ApprovalMasterColumnsList: ColumnMeta[] = [
    { field: 'orgNm', header: 'College Name' },
    { field: 'university', header: 'University' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'qualdateorg', header: 'From' },
    { field: 'qualdateorgf', header: 'To' },
    { field: 'Seat', header: 'Seat' },
    { field: 'pcicirdt', header: 'Date' },
    { field: 'pcirefno', header: 'PCI Ref No' },
    { field: 'pciresno', header: 'PCI Res No' }
];

// Approval  Master List Columns
export const ApprovalMasterCollegeColumnsList: ColumnMeta[] = [
    { field: 'orgNm', header: 'College Name' },
    { field: 'university', header: 'University' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'qualdateorg', header: 'From' },
    { field: 'qualdateorgf', header: 'To' },
    { field: 'Seat', header: 'Seat' },
    { field: 'pcicirdt', header: 'Date' },
    { field: 'pcirefno', header: 'PCI Ref No' },
    { field: 'pciresno', header: 'PCI Res No' },
    { field: 'action', header: 'Action' }
];

// College Entry List Columns
export const CollegeEntryColumnsList: ColumnMeta[] = [
    { field: 'orgnameeng', header: 'College Name' },
    { field: 'university', header: 'University' },
    { field: 'pci_code', header: 'PCI Code' },
    { field: 'Address', header: 'Address' },
    { field: 'StateNm', header: 'State' },
    { field: 'action', header: 'Action' }
];

// College Entry List Columns
export const AllCollegeEntryColumnsList: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'orgnameeng', header: 'College Name' },
    { field: 'StateNm', header: 'State' }
];

// Council Mastet List Columns
export const CouncilMasterColumnsList: ColumnMeta[] = [
    { field: 'Name', header: 'Council Name' },
    { field: 'Address', header: 'Address' },
    { field: 'SateNm', header: 'State' },
    { field: 'action', header: 'Action' }
];

// Hospital List Columns
export const HospitalMasterColumnsList: ColumnMeta[] = [
    { field: 'HospName', header: 'Hospital Name' },
    { field: 'Address', header: 'Address' },
    { field: 'StateName', header: 'State' },
    { field: 'action', header: 'Action' }
];

// All Hospital List Columns
export const AllHospitalColumnsList: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'HospName', header: 'Hospital Name' },
    { field: 'StateName', header: 'State' },
    { field: 'Address', header: 'Address' }
];

// Otheer  Master Columns
export const OtherMasterColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'Data', header: 'Description' },
    { field: 'DataCode', header: 'Type' },
    { field: 'action', header: 'Action' }
];

// Exam Authority List Columns
export const ExamAuthorityListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'EName', header: 'Exam Authority Name' },
    { field: 'action', header: 'Action' }
];

// UniversityMaster List Columns
export const UniversityMasterListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'UName', header: 'University Name' },
    { field: 'Uadd', header: 'Address' },
    { field: 'action', header: 'Action' }
];

//  UserLinkGnoList Columns
export const UserLinkGnoListColumns: ColumnMeta[] = [
    { field: 'full_name', header: 'Name' },
    { field: 'email', header: 'Email' },
    { field: 'mobile', header: 'Mobile' },
    { field: 'status', header: 'Status' },
    { field: 'linkedgno', header: 'Linked GNo.' },
    { field: 'action', header: 'Action' }
];

//  CHANEPHOTO Columns
export const ChangePhotoListColumns: ColumnMeta[] = [
    { field: 'Image', header: 'Image' },
    { field: 'SrNo', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'StudF', header: 'Name' },
    { field: 'RegDt', header: 'Registration Date' },
    { field: 'LastVDate', header: 'Validity Date' },
    { field: 'action', header: 'Action' }
];

export const ReGenerateListColumns: ColumnMeta[] = [
    { field: 'Image', header: 'Image' },
    { field: 'SrNo', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'StudF', header: 'Name' },
    { field: 'RegDt', header: 'Registration Date' },
    { field: 'LastVDate', header: 'Validity Date' },
    { field: 'certificate', header: 'Certificate' },
    { field: 'action', header: 'Action' }
];

// Add RHUSLetter List Columns
export const AddRHUSLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'PassYear', header: 'Pass Year	' },
    { field: 'amount', header: 'Amount' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// Add NIOSLetter List Columns
export const AddNIOSLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// Add GOC Letter List Columns
export const AddGOCLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// Add UniversityLetter List Columns
export const AddUniversityLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'UniBordCol', header: 'University' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// Add BoardLetter List Columns
export const AddBoardLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'UniBordCol', header: 'Board' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// Add CollegeLetter List Columns
export const AddCollegeLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'UniBordCol', header: 'College' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// Add SchoolLetter List Columns
export const AddSchoolLetterListColumns: ColumnMeta[] = [
    { field: 'Name', header: 'Name' },
    { field: 'UniBordCol', header: 'School' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'action', header: 'Action' }
];

// RegCancellation List Columns
export const RegCancellationListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// DataFlow List Columns
export const DataFlowListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'goodstanding_date', header: 'Good Standing' },
    { field: 'letter_date', header: 'Letter' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// Warning Letter List Columns
export const WarningLetterListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// Submission Letter List Columns
export const SubmissionLetterListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// Wrong Affidavit Letter List Columns
export const WrongAffidavitLetterListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// False & Fake Letter List Columns
export const FalseAndFakeListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// ReminderToCollege List Columns
export const ReminderToCollegeListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

// ReminderToSchool List Columns
export const ReminderToSchoolListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

// ReminderToCouncil List Columns
export const ReminderToCouncilListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

// ReminderToMedical List Columns
export const ReminderToMediaclListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ReminderName', header: 'Medical' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

// ReminderToBoard List Columns
export const ReminderToBoardListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ReminderName', header: 'Board' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

// ReminderToNIOS List Columns
export const ReminderToNIOSListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

// ReminderToRUHS List Columns
export const ReminderToRHUSListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'Reference', header: 'Reference' },
    { field: 'action', header: 'Action' }
];

//NOCLetter List Columns
export const NOCLETTERListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

//TransferIn List Columns
export const TransferInLeterListColumns: ColumnMeta[] = [
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'CouncilNm', header: 'Council' },
    { field: 'Address', header: 'Address' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

//PracticalTraining List Columns
export const PracticalTrainingListColumns: ColumnMeta[] = [
    { field: 'FileNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'HospitalNm', header: 'Hospital Name' },
    { field: 'year', header: 'Training Year	' },
    { field: 'created_at', header: 'Entry Date' },
    { field: 'action', header: 'Action' }
];

// FreshApplicationRegisterCOlumn List Columns
export const FreshApplicationRegFirstListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'RegDt', header: 'Reg Date' },
    { field: 'name', header: 'Name' },
    { field: 'PAddress', header: 'Permenant Address' },
    { field: 'AAddress', header: 'Professional Address' },
    { field: 'BOD', header: 'DOB' },
    { field: 'Nationality', header: 'Nationality' },
    { field: 'SSCYr', header: 'SSC Year' },
    { field: 'SSCBrd', header: 'SSC Board' },
    { field: 'HSCYr', header: 'HSC Year' },
    { field: 'HSCBrd', header: 'HSC Board' },
    { field: 'ColName', header: 'College' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'JoingYth', header: 'Joining Y.' },
    { field: 'Passedyth', header: 'Passing Y.' },
    { field: 'PracTrainingQual', header: 'Practical Training' },
    { field: 'PracTrainingJoiningYth', header: 'Practical Training Joining' },
    { field: 'PracTrainingPassedYth', header: 'Practical Training Leaving' }
];

// ApplicationRegisterCOlumn List Columns
export const ApplicationRegFirstListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'Inst.Name	' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' }
];

// ApplicationRegisterCOlumn List Columns

export const ApplicationRegTransferInListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'Inst.Name' },
    { field: 'TRegNo', header: 'Transfer Reg No' },
    { field: 'TRCounCilNm', header: 'Transfer Council' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' }
];

// ApplicatonRegisterCOlumn List Columns
export const ApplicationRegElligibleListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'Inst.Name' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' }
];

// ApplicatonRegisterCOlumn List Columns
export const ApplicationRegRegistrationRenewListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'name', header: 'Name' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' },
    { field: 'BOD', header: 'Birth Date' },
    { field: 'ValidUpTo', header: 'Valid Upto' }
];

// ApplicatonRegisterCOlumn List Columns
export const ApplicationRegDegreeAddListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'name', header: 'Name' },
    { field: 'DegNm', header: 'Degree Added' },
    { field: 'ColName', header: 'Inst.Name' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' }
];

// ApplicatonRegisterCOlumn List Columns
export const ApplicationRegNameChangeListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'name', header: 'Previous Name' },
    { field: 'NameChange', header: 'New Name' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BOD', header: 'Date of Birth' },
    { field: 'NChangDt', header: 'Name Change Date' }
];

// ApplicatonRegisterCOlumn List Columns
export const ApplicationRegGoodStandingListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'name', header: 'Name' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'CertIDt', header: 'Certi Issue Date' }
];

// ApplicatonRegisterCOlumn List Columns
export const ApplicationRegPenatlyListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'name', header: 'Name' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'ValidUpTo', header: 'Valid Upto' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' }
];

// FeeRegisterCOlumn List Columns
export const FeeRegFirstListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'bRegNo', header: 'Reg No' },
    { field: 'EntryNo', header: 'File No.' },
    { field: 'BillSr', header: 'Receipt Ref.No' },
    { field: 'ValidUpTo', header: 'Valid Upto' },
    { field: 'StudNm', header: 'Name' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'AppNm', header: 'App Name' },
    { field: 'AdminAmt', header: 'Development Charges' },
    { field: 'OthAmt', header: 'Other Charges' },
    { field: 'NetAmt', header: 'Total' }
];

// FeeRegisterCOlumn List Columns
export const FeeRegSummaryListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'app_name', header: 'App Name' },
    { field: 'app_count', header: 'Nos' },
    { field: 'admin_total', header: 'Development Cash' },
    { field: 'other_total', header: 'Other Cash' },
    { field: 'total_amount', header: 'Total Cash' }
];

// ApplicationFreshRegisterCOlumn List Columns
export const ApplicationFreshRegFirstListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'name', header: 'Name' },
    { field: 'DegNm', header: 'Permenant Address' },
    { field: 'ColName', header: 'Inst.Name	' },
    { field: 'PayDt', header: 'Payment Date' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'NetAmt', header: 'Amount' }
];

// DegreeDetailsCOlumn List Columns
export const DegreeDetailsListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'EntDt', header: 'App Date' },
    { field: 'DegNm', header: 'Qualification' }
];

// PCIRegister Column List Columns
export const PCIRegisterListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'Name', header: 'Name' },
    { field: 'EntDt', header: 'App Date' },
    { field: 'DegNm', header: 'Qualification' }
];

// CollegeWiseReg Column List Columns
export const CollegeWiseRegListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'SrNo', header: 'Entry No' },
    { field: 'EntDt', header: 'Entry Date' },
    { field: 'Name', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'PAddress', header: 'Address' },
    { field: 'OrgIDt', header: 'Oc Date' },
    { field: 'BOD', header: 'Birth Date' },
    { field: 'PEmail', header: 'Email' },
    { field: 'PPhone', header: 'Phone No' },
    { field: 'SSCYr', header: 'SSC Year' },
    { field: 'SSCBrd', header: 'SSC Board' },
    { field: 'HSCYr', header: 'HSC Year' },
    { field: 'HSCBrd', header: 'HSC Board' },
    { field: 'JoingYth', header: 'Clg Join' },
    { field: 'Passedyth', header: 'Clg Pass' }
];

// Reg Cancellation COlumn List Columns
export const RegistraionCancellationListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'SrNo', header: 'File No.' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'name', header: 'Name' },
    { field: 'RegCDate', header: 'Cancel Date' },
    { field: 'RegCBy', header: 'Cancel By' },
    { field: 'RegCNote', header: 'Note' }
];

// DDRepprt Column List Columns
export const DDReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'ChequeNo', header: 'DD No' },
    { field: 'bRegNo', header: 'Reg No' },
    { field: 'BillSrNo', header: 'Receipt No' },
    { field: 'BankName', header: 'Bank Name' },
    { field: 'StudNm', header: 'Name' },
    { field: 'NetAmt', header: 'Amount' },
    { field: 'ChequeDt', header: 'DD Date' },
    { field: 'PayDt', header: 'PayDt' }
];
// DDRepprt Column List Columns
export const inOutReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'SrNo', header: 'Inward/Outward No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'FromNm', header: 'From' },
    { field: 'ToNm', header: 'To' },
    { field: 'Sub', header: 'Subject' },
    { field: 'EntDt', header: 'Entry Date' },
    { field: 'TypeNo', header: 'Main Type' },
    { field: 'Data', header: 'Sub Type' },
    { field: 'ToAddress', header: 'Address' },
    { field: 'mobile', header: 'Mobile' },
    { field: 'Note1', header: 'Note' }
];
// ProvOrg Column List Columns
export const ProvOrgReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'RegDt', header: 'Reg Date' },
    { field: 'name', header: 'Name' },
    { field: 'SrNo', header: 'Entry No' },
    { field: 'ProIDate', header: 'Prov Prepare' },
    { field: 'OrgIDt', header: 'Orig Prepare' }
];

// GNoWiseCOlumn List Columns
export const GNoWiseListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'RegNo', header: 'Reg No.' },
    { field: 'full_name', header: 'Name' },
    { field: 'phone', header: 'Mobile' },
    { field: 'email', header: 'Email' },
    { field: 'address', header: 'Address' }
];

// DownloadReport COlumn List Columns
export const DownloadReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'app_name', header: 'App Name' },
    { field: 'type', header: 'Type' },
    { field: 'date', header: 'Date' },
    { field: 'file_url', header: 'Download' }
];

// Registration Validation Report Column List Columns
export const RegistrationValidationReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'app_name', header: 'Name' },
    { field: 'SrNo', header: 'File No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'EntDt', header: 'Reg Date' },
    { field: 'LastVDate', header: 'Valid Upto' },
    { field: 'PEmail', header: 'Email' }
];

// Government Report Column List Columns
export const GovernmentReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'SrNo', header: 'Entry No' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'Name', header: 'Name' },
    { field: 'BOD', header: 'Birth Date' },
    { field: 'Gender', header: 'Gender' },
    { field: 'LastVDate', header: 'Last valid' },
    { field: 'PAddress', header: 'Address' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'PPhone', header: 'Mobile' },
    { field: 'PEmail', header: 'Email' }
];

// Application Detail Report Column List Columns
export const ApplicationDetailnReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'AppNm', header: 'Application Name' },
    { field: 'bill_no', header: 'Bill No' },
    { field: 'PayDt', header: 'Bill Date' },
    { field: 'NetAmt', header: 'Amount' }
];

// ScrutinyColumn
export const ScrutinyListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'SrNo', header: 'File No' },
    { field: 'name', header: 'Name' },
    { field: 'Gender', header: 'Gender' },
    { field: 'BOD', header: 'DOB' },
    { field: 'PPhone', header: 'Phone' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'ColName', header: 'College ' },
    { field: 'verification_date', header: 'Verification Date' },
    { field: 'remainder_date', header: 'Reminder Date' },
    { field: 'verification_status', header: 'Verification Status' },
    { field: 'action', header: 'Action' }
];

// Scrutiny Verification List Columns
export const ScrutinyVerificationColumnsList: ColumnMeta[] = [
    { field: 'comment', header: 'Verification Note' },
    { field: 'verification_to', header: 'Verification To' },
    { field: 'created_at', header: 'Verification Order Date' },
    { field: 'verification_date', header: 'Verification Send Date' },
    { field: 'file_url', header: 'Verification Files' },
    { field: 'reply', header: 'Reply' },
    { field: 'reply_file', header: 'Reply Files' },
    { field: 'action', header: 'Action' }
];

// Scrutiny View Document List Columns
export const ScrutinyViewDocumentColumnsList: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'DocName', header: 'Document Name' },
    { field: 'action', header: 'View' }
];

// DegreeAdditionScrutinyColumn
export const DegreeAdditionScrutinyListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'EntryNo', header: 'File No' },
    { field: 'StudNm', header: 'Name' },
    { field: 'applicant_details.Gender', header: 'Gender' },
    { field: 'applicant_details.BOD', header: 'DOB' },
    { field: 'applicant_details.PPhone', header: 'Phone' },
    { field: 'get_latest_college.DegNm', header: 'Qualification' },
    { field: 'get_latest_college.ColName', header: 'College' },
    { field: 'action', header: 'Action' }
];

// ReEntryScrutinyColumn
export const ReEntryScrutinyListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'RegNo', header: 'Reg No' },
    { field: 'StudNm', header: 'Name' },
    { field: 'DegNm', header: 'Qualification' },
    { field: 'case', header: 'Case' },
    { field: 'action', header: 'Action' }
];

//Report columnc
export const ReportsColumns: ColumnMeta[] = [
    { field: 'name', header: 'Report Name' },
    { field: 'type', header: 'Description' }
];

// AccountLedgerReport Column List Columns
export const AccountLedgerReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'CurrDate', header: 'Date' },
    { field: 'RefNo', header: 'Voucher' },
    { field: 'Credit', header: 'Credit' },
    { field: 'Debit', header: 'Debit' },
    { field: 'closing', header: 'Closing' },
    { field: 'Message', header: 'Remark' }
];

// Cash Book DetailReport Column List Columns
export const CashBookDetailrReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'date', header: 'Date' },
    { field: 'credit', header: 'Credit' },
    { field: 'debit', header: 'Debit' },
    { field: 'closing', header: 'Closing' },
    { field: 'voucher', header: 'Voucher' },
    { field: 'party', header: 'Party Name' },
    { field: 'message', header: 'Remark' }
];

// Bank Book DetailReport Column List Columns
export const BankBookDetailrReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'date', header: 'Date' },
    { field: 'debit', header: 'Deposit' },
    { field: 'credit', header: 'Withdrawal' },
    { field: 'closing', header: 'Closing' },
    { field: 'CqNo', header: 'Chq/Neft' },
    { field: 'voucher', header: 'Voucher' },
    { field: 'party', header: 'Party Name' },
    { field: 'message', header: 'Remark' }
];

// Jv Book DetailReport Column List Columns
export const JvBookDetailrReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'date', header: 'Date' },
    { field: 'party', header: 'Party Name' },
    { field: 'voucher', header: 'Voucher' },
    { field: 'debit', header: 'Debit' },
    { field: 'credit', header: 'Credit' },
    { field: 'message', header: 'Remark' }
];

// Trial Balance Report Column List Columns
export const TrialBalanceReportListColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'name', header: 'Account Name' },
    { field: 'debit', header: 'Debit Trm' },
    { field: 'credit', header: 'Credit Trm' },
    { field: 'group', header: 'Group' }
];

// Profit Loss Report Column List Columns
export const ExpenseReportListColumns: ColumnMeta[] = [
    { field: 'name', header: 'Expense' },
    { field: 'debit', header: 'Amount' }
];

// Profit Loss Report Column List Columns
export const IncomeReportListColumns: ColumnMeta[] = [
    { field: 'name', header: 'Income' },
    { field: 'credit', header: 'Amount' }
];

//Banner Columns
export const BannerColumns: ColumnMeta[] = [
    { field: 'banner_image', header: 'Image' },
    { field: 'action', header: 'Action' }
];

//Notice Columns
export const NoticeColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'notice_title', header: 'Title' },
    { field: 'notice_file', header: 'File' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action' }
];

//Annoucment Columns
export const AnnoucmentColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'latest_update_title', header: 'Title' },
    { field: 'latest_update_file', header: 'File' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action' }
];

//StaticRefresher Columns
export const StaticRefresherColumns: ColumnMeta[] = [
    { field: 'refresher_schedule', header: 'File' },
    { field: 'action', header: 'Action' }
];

//Inquiry Columns
export const InquiryColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No' },
    { field: 'name', header: 'Name' },
    { field: 'email', header: 'Email' },
    { field: 'mobile', header: 'Phone No' },
    { field: 'message', header: 'Message' }
];

//Gallary Columns
export const GallaryColumns: ColumnMeta[] = [
    { field: 'sr_no', header: 'Sr No.' },
    { field: 'image', header: 'Image' },
    { field: 'status', header: 'Status' },
    { field: 'action', header: 'Action' }
];
export const RoleColumns: ColumnMeta[] = [
    { field: 'name', header: 'Role' },
    { field: 'action', header: 'Action' }
];
